import Link from "@mui/material/Link";
import typography from "../../../../assets/theme/base/typography";
import { MDBox } from "../MDBox";
import { MDTypography } from "../MDTypography";
import sa_flag from "../../../../assets/gif/sa_flag.gif";
import { ClientFooterBanner } from "./ClientFooterBanner";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../../../State/user.Atom";
import config from "../../../../config";

interface ICompany {
  href: string;
  name: string;
}

interface ILink {
  href: string;
  name: string;
}

interface IFooterProps {
  company?: ICompany;
  links?: ILink[];
  buildId?: string;
}

const defaultCompany: ICompany = { href: "https://www.bee123.co.za/", name: "BEE123 (Pty) Ltd" };

const defaultLinks: ILink[] = [
  { href: `${config.publicUrl}/Content/StaticFiles//BEE123_Terms_and_Conditions_2023.pdf`, name: "Terms & Conditions" },
  { href: `${config.publicUrl}/Content/StaticFiles//HRP_BEE123_PAIA_Manual.pdf`, name: "PAIA Policy" },
  { href: "https://www.bee123.co.za/contact/", name: "Contact Us" },
];

export const Footer: React.FC<IFooterProps> = ({
  company = defaultCompany,
  links = defaultLinks,
  buildId = "Dev Mode"
}: IFooterProps) => {
  const { href, name } = company;
  const { size } = typography;
  const currentUser = useRecoilValue(UserAtom);

  const renderLinks = () =>
    links!.map((link) => (
      <MDBox key={link.name} component="li" px={1} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <MDTypography variant="button" fontWeight="regular" color="text">
            {link.name}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <>
      {currentUser.isClient && <ClientFooterBanner />}
      <MDBox
        width="100%"
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        justifyContent="space-between"
        alignItems="center"
        sx={currentUser.isClient ? { backgroundColor: "#FFFFFF" } : {}}
      >
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          color="text"
          fontSize={size.sm}
          px={1.5}
        >
          Copyright &copy; {new Date().getFullYear()}, &nbsp;
          <Link href={href} target="_blank">
            <MDTypography variant="button" fontWeight="medium">
              &nbsp;{name}&nbsp;({buildId})
            </MDTypography>
          </Link>
        </MDBox>
        <MDBox
          component="ul"
          sx={({ breakpoints }: any) => ({
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            listStyle: "none",
            mt: 3,
            mb: 0,
            p: 0,

            [breakpoints.up("lg")]: {
              mt: 0,
            },
          })}
        >
          {renderLinks()}
          <MDBox component="li" px={2} lineHeight={1}>
            <img className="FooterImage" src={sa_flag} />
            <MDTypography variant="button" fontWeight="regular" color="text" ml={0.5}>
              Proudly developed in South Africa
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </>
  );
}
